import CountDown from './components/CountDown.vue';

module.exports = CountDown;



// WEBPACK FOOTER //
// ./src/index.js